import { OrganizationSize } from "../../autogen/bff-api";

export const displayOrganizationSize = (size: OrganizationSize): string => {
  switch (size) {
    case OrganizationSize.FiftyToTwoHundredAndFifty:
      return "50-250";
    case OrganizationSize.OneToTen:
      return "1-10";
    case OrganizationSize.TenThousandPlus:
      return "10000+";
    case OrganizationSize.TenToFifty:
      return "10-50";
    case OrganizationSize.ThousandToTenThousand:
      return "1000-10000";
    case OrganizationSize.TwoHundredAndFiftyToThousand:
      return "250-1000";
  }
};
